import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CdeCatalog from "./components/cdeCatalog/cdeCatalog";
import CrfLibrary from "./components/crfLibrary/crfLibrary";
import CdeDetails from "./components/cdeDetails/cdeDetails";
import NocReport from "./components/nocReport/nocReport";
import CrfListing from "./components/crfListing/crfListing";

import '@iframe-resizer/child';

function App() {
  return (
    <div className="AppContainer">
      <BrowserRouter>
        <Routes>
          <Route exact path="/curesickle" element={<div>This is Homepage</div>} />
          <Route
            exact
            path="/curesickle/crf-library"
            element={
              <div className="crfLibrary">
                <CrfLibrary />
              </div>
            }
          />
          <Route
            exact
            path="/curesickle/cde-catalog"
            element={
              <div className="cdeCatalog">
                <CdeCatalog />
              </div>
            }
          />
          <Route 
            exact
            path="/curesickle/cde-details/:reportType/:crfcdeId/:domain?/:subDomain?/:crfName?"
            element={
              <div className="cdeDetails">
                <CdeDetails />
              </div>
            }
          />
          <Route 
            exact
            path="/curesickle/noc-report/:crfId/:crfName"
            element={
              <div className="nocReport">
                <NocReport />
              </div>
            }
          />
          <Route 
            exact
            path="/curesickle/crf-listing"
            element={<CrfListing />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
